import { Action } from '@ngrx/store';
import { PrimaryFilter } from '@deltager/organizers/admin/shared/classes/table-base/list-filter.model';
import { ReportingTransactionListFilter } from '@deltager/organizers/admin/modules/reporting/reporting-main/transactions/models/reporting-transaction-list-filter.model';
import { ReportingSettlementListFilter } from '../settlements/models/reporting-settlement-list.filter';
import { TransactionExportParams } from '../transactions/models/transaction-export-params.model';
import { ExportFormat } from '@deltager/organizers/admin/shared/enums/export-format.enum';

export enum ReportingActionTypes {
  TransactionFiltersChanged = '[Reporting transaction]: Transaction filters changed.',
  TransactionLoadingChanged = '[Reporting transaction]: Loading changed.',
  TransactionExportTriggered = '[Reporting transaction]: Export triggered.',
  FiltersRefreshTriggered = '[Reporting transaction]: Filters refresh has been triggered.',
  SettlementFiltersChanged = '[Reporting settlement]: Settlement filters changed.',
  SettlementLoadingChanged = '[Reporting settlement]: Loading changed.',
  SettlementExportTriggered = '[Reporting settlement]: Export triggered.',
}

export class TransactionFiltersChangedAction implements Action {
  readonly type = ReportingActionTypes.TransactionFiltersChanged;

  constructor(public readonly payload: PrimaryFilter<ReportingTransactionListFilter>) {}
}

export class TransactionLoadingChangedAction implements Action {
  readonly type = ReportingActionTypes.TransactionLoadingChanged;

  constructor(public readonly payload: boolean) {}
}

export class TransactionExportTriggeredAction implements Action {
  readonly type = ReportingActionTypes.TransactionExportTriggered;

  constructor(public readonly payload: TransactionExportParams) {}
}

export class FiltersRefreshTriggeredAction implements Action {
  readonly type = ReportingActionTypes.FiltersRefreshTriggered;
}

export class SettlementFiltersChangedAction implements Action {
  readonly type = ReportingActionTypes.SettlementFiltersChanged;

  constructor(public readonly payload: PrimaryFilter<ReportingSettlementListFilter>) {}
}

export class SettlementLoadingChangedAction implements Action {
  readonly type = ReportingActionTypes.SettlementLoadingChanged;

  constructor(public readonly payload: boolean) {}
}

export class SettlementExportTriggeredAction implements Action {
  readonly type = ReportingActionTypes.SettlementExportTriggered;

  constructor(public readonly payload: ExportFormat) {}
}
